import React, { ComponentType } from 'react'
import uniqid from 'uniqid'
import { FormatDate } from '../../utils/date'

export interface InsightsLinkProps {
  className?: string
  slug: string
  title: string
}

interface ArticleType {
  subTitle: string
  slugPrefix?: string
}

export interface InsightResultItem {
  slug: string
  title: string
  abstract?: string
  publishedDate?: string
  articleType: ArticleType
  languages: {
    title: string
    slug: string
  }
}

export interface InsightResultProps {
  items: InsightResultItem[]
  renderLink?: ComponentType<InsightsLinkProps>
}

const RenderLinkDefault = ({
  className = '',
  slug,
  title
}: InsightsLinkProps) => (
  <a className={className} href={slug} aria-label={title}>
    {title}
  </a>
)

// This is being used in sustainable fitch.
export const InsightsResults = ({
  items,
  renderLink: Link = RenderLinkDefault
}: InsightResultProps) => (
  <div className="column__three">
    {items.map((item) => {
      if (!item) return null
      const {
        slug,
        title,
        abstract,
        articleType,
        publishedDate /* , languages */
      } = item
      return (
        <div className="column" key={uniqid()}>
          <div className="grid__content">
            <div className="heading--sub heading--tag">
              <span>{articleType.subTitle.toUpperCase()}</span>
              {publishedDate
                ? ` / ${FormatDate(
                    publishedDate,
                    'ccc dd MMM, yyyy'
                  ).toUpperCase()}`
                : ''}
            </div>
            <h3 className="heading--5">
              <Link title={title} slug={slug} />
            </h3>
            {abstract ? <p>{abstract}</p> : ''}
          </div>
        </div>
      )
    })}
  </div>
)
